import React from 'react';

const DeleteConfirmModal = ({ isOpen, message, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-xs">
        <h3 className="text-lg font-bold mb-4">Confirm Delete</h3>
        <p className="mb-4">{message}</p>
        <div className="flex gap-2">
          <button 
            className="bg-gray-300 text-gray-700 px-4 py-2 rounded flex-1" 
            onClick={onCancel}
          >
            Cancel
          </button>
          <button 
            className="bg-red-500 text-white px-4 py-2 rounded flex-1" 
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
